import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

/**
 * 返回门户网站的 composable
 */
export function useBackToPortal() {
  const router = useRouter()
  const authStore = useAuthStore()

  /**
   * 根据当前域名生成portal URL
   *
   * 动态生成portal URL，避免硬编码环境变量
   * 例如：https://controltower-tenant-stage.walltechsystem.com/portal
   *
   * @returns {string} portal URL
   */
  const generatePortalUrl = (): string => {
    const currentOrigin = window.location.origin
    return `${currentOrigin}/portal`
  }

  /**
   * 处理返回门户网站的逻辑
   * 根据存储的来源参数决定跳转目标，如果已登录则获取 code
   */
  const handleBackToPortal = async() => {
    try {
      // 获取存储的来源参数
      const sourceFrom = authStore.sourceFrom

      // 根据来源参数决定跳转目标
      let targetUrl = ''
      if (sourceFrom === 'home') {
        targetUrl = import.meta.env.VITE_HOME_URL
      } else if (sourceFrom === 'portal'|| sourceFrom === 'portalnew') {
        // 根据当前域名动态生成portal URL
        targetUrl = generatePortalUrl()
      } else {
        // 默认跳转到首页
        router.push('/')
        return
      }

      // 如果已登录，获取 code 并带上
      if (authStore.isAuthenticated) {
        try {
          const code = await authStore.getReturnCode()
          const url = new URL(targetUrl)
          url.searchParams.set('code', code)
          window.location.href = url.toString()
        } catch (error) {
          console.error('[CT_AUTH] 获取返回Code失败:', error)
          // 如果获取 code 失败，直接跳转
          window.location.href = targetUrl
        }
      } else {
        // 未登录，直接跳转
        window.location.href = targetUrl
      }
    } catch (error) {
      console.error('[CT_AUTH] 返回首页失败:', error)
      router.push('/')
    }
  }

  return {
    handleBackToPortal
  }
}
